var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmail = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 34 28",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M30.333.667H3.666C1.833.667.35 2.167.35 4L.333 24c0 1.833 1.5 3.333 3.333 3.333h26.667c1.833 0 3.333-1.5 3.333-3.333V4c0-1.833-1.5-3.333-3.333-3.333Zm0 6.666L17 15.667 3.666 7.333V4L17 12.333 30.333 4v3.333Z"
})));
export default SvgEmail;